import { getReporting, filterReporting, getRatingCount } from './api/Apps'

export const getApplications = async function (filter: filterReporting) {
  const applicationsList = getReporting(filter, 'byapplication')
    .then((res) => parseResponse(res))
    .then(({ data }) => {
      return data === 'no Data selected' || data === undefined ? [] : data
    })

  await Promise.all([applicationsList])
  return applicationsList
}

const parseResponse = (res: any) => {
  const count = parseInt(res.headers.get('count')) || 0
  return res
    .clone()
    .json()
    .then((data: any) => ({ data, count }))
    .catch(() => res.text().then((text: string) => ({ data: text, count: 0 })))
}

export const getData = async function (filter: filterReporting, datePeriod: number) {
  let dataObject = {}
  // areaData - AreaChart
  const areaData = getReporting(filter, 'byday')
    .then((res) => parseResponse(res))
    .then(({ data }) => {
      if (data === 'no Data selected' || data === undefined) {
        return (dataObject = { ...dataObject, areaChartData: [] })
      } else {
        return (dataObject = { ...dataObject, areaChartData: data })
      }
    })

  // allSingleRatings -Table
  const allSingleRatings = getReporting(filter, 'bydetails', 'date', 'DESC')
    .then((res) => parseResponse(res))
    .then(({ data, count }) => {
      if (data === 'no Data selected' || data === undefined) {
        return (dataObject = { ...dataObject, allSingleRatings: [], totalRatings: 0 })
      } else {
        return (dataObject = { ...dataObject, allSingleRatings: data, totalRatings: count })
      }
    })

  // applicationList -Table
  const applicationsList = getReporting(filter, 'byapplication')
    .then((res) => parseResponse(res))
    .then(({ data }) => {
      if (data === 'no Data selected' || data === undefined) {
        return (dataObject = { ...dataObject, applicationListData: [] })
      } else {
        return (dataObject = { ...dataObject, applicationListData: data })
      }
    })

  // ratingsCount - RatingSidebar
  const ratingsCount = getReporting(filter, 'byrating')
    .then((res) => parseResponse(res))
    .then(({ data }) => {
      if (data === 'no Data selected' || data === undefined) {
        return (dataObject = { ...dataObject, ratingsCount: [] })
      } else {
        return (dataObject = { ...dataObject, ratingsCount: data })
      }
    })

  // average for rating sidebar
  const ratingsAverage = getReporting(filter, 'average')
    .then((res) => parseResponse(res))
    .then(({ data }) => {
      if (data === 'no Data selected' || data === undefined) {
        return (dataObject = { ...dataObject, ratingsAverage: {} })
      } else {
        return (dataObject = { ...dataObject, ratingsAverage: data })
      }
    })
  /* // teamWithinDepartmentList - Table
  const teamWithinDepartmentList = getReporting(filter, 'bydepartment')
    .then((res) => parseResponse(res))
    .then((val) => {
      if (val === 'no Data selected' || val === undefined) {
        return (dataObject = {
          ...dataObject,
          teamDepartmentListData: []
        })
      } else {
        return (dataObject = {
          ...dataObject,
          teamDepartmentListData: val
        })
      }
    })

  // departmentList - Table
  const departmentList = getReporting(filter, 'byMainDepartment3')
    .then((res) => parseResponse(res))
    .then((val) => {
      if (val === 'no Data selected' || val === undefined) {
        return (dataObject = {
          ...dataObject,
          departmentListData: []
        })
      } else {
        return (dataObject = {
          ...dataObject,
          departmentListData: val
        })
      }
    }) */
  const filterHistory = {
    ...filter,
    to: filter.from,
    from: new Date(
      new Date(new Date(filter.from).setDate(new Date(filter.from).getDate() - datePeriod)).setHours(0, 0, 0, 0)
    ).getTime()
  }
  // average for rating sidebar History
  const ratingsAverageHistory = getReporting(filterHistory, 'average')
    .then((res) => parseResponse(res))
    .then(({ data }) => {
      if (data === 'no Data selected' || data === undefined) {
        return (dataObject = { ...dataObject, ratingsAverageHistory: {} })
      } else {
        return (dataObject = { ...dataObject, ratingsAverageHistory: data })
      }
    })
  const ratingCountHistory = getRatingCount(filterHistory)
    .then((res) => parseResponse(res))
    .then(({ data }) => {
      if (data === 'no Data selected' || data === undefined) {
        return (dataObject = { ...dataObject, ratingCountHistory: 0 })
      } else {
        return (dataObject = { ...dataObject, ratingCountHistory: data.count })
      }
    })

  await Promise.all([
    ratingsAverage,
    ratingsCount,
    areaData,
    ratingCountHistory,
    allSingleRatings,
    applicationsList,
    ratingsAverageHistory
  ])
  return dataObject
}
